import { render, staticRenderFns } from "./CropsTableController.vue?vue&type=template&id=b470b7b0&scoped=true&"
import script from "./CropsTableController.vue?vue&type=script&lang=ts&"
export * from "./CropsTableController.vue?vue&type=script&lang=ts&"
import style0 from "./crops-table-controller.scss?vue&type=style&index=0&id=b470b7b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b470b7b0",
  null
  
)

export default component.exports